export default {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};
